import { DynamicObject } from 'src/utils/commonTypes';

import { IrequestToPlayNextVideo } from './PlayerInterface/PlayerCallbackInterface';
import { mixpanelObject } from '../../../utils/analytics/mixpanel/mixpanel';
import {
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_ELEMENT,
  MIXPANEL_EVENTS_PLAYER_CTAS,
  MIXPANEL_SKIP
} from '../../../utils/analytics/mixpanel/mixpanelConstants';
import { playerCtaEvent } from '../../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { clearCtaEventsProperty } from '../../../utils/analytics/mixpanel/mixpanelHelper';
import { getLocalStorageInteger } from '../../../utils/browserStorageHandler';

export function requestToPlayNextVideo({
  contentid,
  indexObject,
  playerRef,
  playNext,
  similarFromReco
}: IrequestToPlayNextVideo): void {
  const { country = 'IN', playerConfig = {} } = playerRef;
  const { modelName = '' } = playerConfig;
  let filterarray: DynamicObject = {};
  let found = false;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < similarFromReco.length; i++) {
    if (contentid === similarFromReco[i].id) {
      filterarray = similarFromReco[i];
      found = true;
      break;
    }
  }
  if (found === true && filterarray) {
    if (indexObject === undefined) {
      indexObject = {
        assetSubtype: filterarray.origin ? 'Reco' : undefined,
        talamoosModelName: modelName,
        origin: filterarray.origin,
        clickID: filterarray.clickID,
        horizontalIndex: 1
      };
    }
    indexObject.title = 'Up Next (Player)';
    playNext({
      newContentObject: filterarray
    });
  }
}

export function createSkipContentButton({ playerRef }: any) {
  const {
    similarFromReco = [],
    singlePlayDetails = {},
    playerConfig
  } = playerRef || {};
  const { requestToPlayNextVideo } = playerConfig || {};
  const isPartnerContent =
    !!singlePlayDetails?.assetDetails?.content_partner_details
      ?.content_partner_id;
  const mandatoryRegistrationPopupCount = getLocalStorageInteger(
    'mandatoryRegistrationPopupCount'
  );
  if (
    !(mandatoryRegistrationPopupCount && mandatoryRegistrationPopupCount >= 5)
  ) {
    const targetDiv = document.querySelector('.main-container-1');
    const skipDiv = document.querySelector('.skip-button');
    const { messages = {} } = window.translationsAndConfigs || {};
    if (
      targetDiv &&
      !skipDiv &&
      Object.keys(messages).length &&
      similarFromReco &&
      similarFromReco[0] &&
      similarFromReco[0].id &&
      !isPartnerContent
    ) {
      const skipLink = document.createElement('div');
      skipLink.className = `skip-button subscribe-link subscribemsg_${messages.localeLanguage} skip-button-2`;
      skipLink.innerText = messages.Player_Skip_UnsubscribedUser_Text;
      skipLink.addEventListener('click', (e) => {
        // below function is same as play next function of carousel
        clearCtaEventsProperty(mixpanelObject);
        mixpanelObject[MIXPANEL_ELEMENT] = MIXPANEL_SKIP;
        mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_EVENTS_PLAYER_CTAS;
        playerCtaEvent();
        requestToPlayNextVideo({
          contentid: similarFromReco[0].id,
          indexObject: undefined,
          playerRef,
          similarFromReco
        });
      });
      targetDiv.appendChild(skipLink);
    }
  }
}
